import { ErrorHandler } from "@/Helpers/ErrorHandler.js"
import { Paginator } from "@/Helpers/Paginator.js"
import { convertObjectKeysToCamelCase } from "@/Helpers/Utils.js"
import ApplianceRateRepository from "@/repositories/ApplianceRateRepository.js"
import { resources } from "@/resources.js"

export class ApplianceRateService {
  constructor(appliancePersonId) {
    this.repository = ApplianceRateRepository
    this.ratesList = []

    this.paginator = new Paginator(
      `${resources.appliances.person.rates}${appliancePersonId}/rates`,
    )
    this.paginator.perPage = 15
  }

  async editApplianceRate(rate, adminId, personId) {
    try {
      let terms = {
        newCost: rate.tempCost,
        admin_id: adminId,
        person_id: personId,
      }

      let response = await this.repository.update(rate.id, terms)

      if (response.status === 200 || response.status === 201) {
        return response
      } else {
        return new ErrorHandler(response.error, "http", response.status)
      }
    } catch (e) {
      const responseData = e.response?.data ?? {}
      const errorMessage =
        responseData.errors?.rate?.[0] ?? responseData.message
      return new ErrorHandler(errorMessage, "http", e.response?.status)
    }
  }

  updateRatesList(ratesData) {
    this.ratesList = ratesData.map((rate) => {
      return convertObjectKeysToCamelCase(rate)
    })
    return this.ratesList
  }
}
